import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { CarsModel } from 'src/models/cars/cars';
import { API_url } from '../api.setup';
import Cars from 'src/content/pages/settings/cars';

const API_Controller = '/cars';

const CarsService = {
  getAllCars: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);

      return response.data as CarsModel[];
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
      throw error;
    }
  },

  getCar: async (carId) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/get?id=${carId}`);

      return response.data as CarsModel
    } catch (error) {
      console.error('Response error:', error.response.data);
    }
  },

  addCars: async (dataToUpdate: CarsModel) => {
    try {
      const remodel = {
        Name: dataToUpdate.name,
        Status: dataToUpdate.status,
        BrandId: dataToUpdate.brand.id,
        CarCategoryId: dataToUpdate.carCategory.id
      };
      const response = await axios.post(`${API_url}${API_Controller}`, remodel);
      enqueueSnackbar(`Car "${dataToUpdate.name}" Added Successfully`, {
        variant: 'success'
      });
      return response.data as CarsModel;
    } catch (error) {
      console.error('Error updating data:', error);
      throw error;
    }
  },

  deleteCars: async (carsId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${carsId}`
      );
      enqueueSnackbar(`Car "${data.name}" Deleted Successfully`, {
        variant: 'success'
      });
      return response.data as CarsModel;
    } catch (error) {
      throw error;
    }
  },

  editCars: async (editedData: CarsModel) => {
    try {
      const remodel = {
        Id: editedData.id,
        Name: editedData.name,
        Status: editedData.status,
        BrandId: editedData.brand.id,
        CarCategoryId: editedData.carCategory.id
      };
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        remodel
      );

      const updatedData = {
        ...response.data,
        brand: editedData.brand,
        carCategory: editedData.carCategory
      };
      enqueueSnackbar(`Car "${editedData.name}" Edited Successfully`, {
        variant: 'success'
      });
      return updatedData as CarsModel;
    } catch (error) {
      throw error;
    }
  },
  uploadCarImage: async (carsId: number, file: File) => {
    try {
      const formData = new FormData();
      formData.append('file', file); 
      const response = await axios.post(`${API_url}${API_Controller}/upload?carId=${carsId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      enqueueSnackbar(`Image uploaded successfully for cars ID ${carsId}`, {
        variant: 'success'
      });
      return response.data;
      
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
      throw error;
    }
  },
};

export default CarsService;
